import $ from 'jquery';
import _ from 'lodash';
import { getState, getStatePure } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import { editorConfig } from '~config';
import { ensureAllPagesHavePreview } from '~core';
import { handleChangePageBtn } from '~src/multipages';
import { FEATURES, isFeatureEnabled } from '../features';

export const addPagesToSidebar = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const canUserAddPages = await isFeatureEnabled(FEATURES.ADD_PAGES);

  await ensureAllPagesHavePreview();

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  let pageIndex = 0;
  const totalPages = pages.length;

  const html = pages.reduce((acc, page) => {
    const pagePreviewUrl = _.get(
      page,
      'preview.url',
      editorConfig.pagePreviewPlaceholder
    );

    // Build menu items based on page position and total count
    let menuItems = '';

    // Add "Move Up" if not the first page
    if (pageIndex > 0) {
      menuItems += `
        <div class="item context-menu-child"
          data-page-move-up="${pageIndex}"
          data-page-id="${page.objectId}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M12 2.25a.75.75 0 0 1 .53.22l7 7a.75.75 0 1 1-1.06 1.06L12.75 4.81V21a.75.75 0 0 1-1.5 0V4.81L5.53 10.53a.75.75 0 0 1-1.06-1.06l7-7a.75.75 0 0 1 .53-.22z"></path>
          </svg>
          Sposta Su
        </div>`;
    }

    // Add "Move Down" if not the last page
    if (pageIndex < totalPages - 1) {
      menuItems += `
        <div class="item context-menu-child"
          data-page-move-down="${pageIndex}"
          data-page-id="${page.objectId}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M12 21.75a.75.75 0 0 1-.53-.22l-7-7a.75.75 0 1 1 1.06-1.06l5.72 5.72V3a.75.75 0 0 1 1.5 0v16.19l5.72-5.72a.75.75 0 1 1 1.06 1.06l-7 7a.75.75 0 0 1-.53.22z"></path>
          </svg>
          Sposta Giù
        </div>`;
    }

    // Add "Delete" only if there's more than one page
    if (totalPages > 1) {
      menuItems += `
        <div class="item context-menu-child item--danger"
          data-page-btn-index="${pageIndex}"
          data-page-id="${page.objectId}"
          data-page-url="${pagePreviewUrl}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path>
          </svg>
          Elimina
        </div>`;
    }

    // Only show the context menu trigger if there are menu items
    const contextMenuHtml = menuItems
      ? `
      <div class="option-button-container sidebar-context-menu-trigger">
        <div class="option-button-container-relative">
          <div class="context-menu context-menu-child sidebar-context-menu bg-color-existing-canvas color-existing-canvas">
            ${menuItems}
          </div>
        </div>
      </div>`
      : '';

    const template = `
          <div class="editor-sidebar-item-container ${
            pageIndex === currentPageIndex ? 'editor-sidebar-page-current' : ''
          }" data-page-index="${pageIndex}" id="editor-page-${pageIndex}">
                  <div class="editor-sidebar-slides-pagination"><span>${
                    pageIndex + 1
                  }</span></div>
                  <div class="editor-sidebar-page-preview">
                      ${
                        page.imgData
                          ? `<img src="data:image/png;base64, ${page.imgData}" />`
                          : `<img src="${pagePreviewUrl}" />`
                      }
                  </div>
                  ${contextMenuHtml}
              </div>
              `;

    acc += template;
    pageIndex++;
    return acc;
  }, '');
  if (isGlobalEditor || canUserAddPages) {
    const htmlButton = `
      <button
        id="editor-menu-add-page"
        class="g-btn g-btn-outline g-btn-size-sm"
      >
        Aggiungi
      </button>`;
    $('#btn-manage-pages').html(htmlButton);
  }

  $('#editor-sidebar-pages').html(html);

  $('body').off('click', '[data-page-index]');
  $('body').on('click', '[data-page-index]', handleChangePageBtn);
  // makePagesDraggable();
};
